import React, { useCallback, useState } from 'react';
import { PaletteIcon } from 'lucide-react';
import { LegalModal } from './LegalModal';
import { brand } from '../../data/config';
import { legalDocs, type LegalDoc } from '../../data/legal';
export function SiteFooter() {
  const [openDoc, setOpenDoc] = useState<LegalDoc | null>(null);
  const close = useCallback(() => setOpenDoc(null), []);
  return <footer className="bg-lavender-soft py-12" data-id="element-249" data-mp="3bs4m4z92up8u">
      <div className="mx-auto max-w-xl px-5 text-center" data-id="element-250" data-mp="3brbhq4xlcbtv">
        <p className="flex items-center justify-center gap-3 font-display text-xl font-extrabold uppercase tracking-[0.04em] text-ink" data-id="element-251" data-mp="3ftg90x0kgwdc">
          <PaletteIcon className="h-7 w-7 text-coral" aria-hidden="true" data-id="element-252" data-mp="31v8hx5q7opa3" />
          {brand}
        </p>
        <span aria-hidden="true" className="mx-auto mt-5 block h-px w-full bg-gradient-to-r from-transparent via-lavender-line to-transparent" data-id="element-253" data-mp="36tjtpm02h9uy" />
        <div className="mt-5 space-y-1 text-[15px] leading-relaxed text-body" data-id="element-254" data-mp="151n4xaow23i8">
          <p data-id="element-255" data-mp="14zkguw7aqkg5">© 2026 — {brand}</p>
          <p data-id="element-256" data-mp="3du5bl00t0unj">Digitális termék · Azonnali hozzáférés e-mailben.</p>
          <p data-id="element-257" data-mp="3dskk5j9sdrtw">
            A kreatív önkifejezés és az érzelmi jóllét eszköze. Nem helyettesíti az orvosi vagy pszichológiai kezelést.
          </p>
        </div>
        <nav aria-label="Jogi információk" className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2" data-id="element-258" data-mp="3mlp597ql4ebn">
          {legalDocs.map(doc => <button key={doc.id} type="button" onClick={() => setOpenDoc(doc)} aria-haspopup="dialog" className="text-[15px] font-semibold text-lavender underline underline-offset-4 transition-colors duration-150 hover:text-lavender-deep focus:outline-none focus-visible:ring-2 focus-visible:ring-lavender-deep" data-id="element-259" data-mp="3inriebkae4bf">
              {doc.title}
            </button>)}
        </nav>
      </div>
      <LegalModal doc={openDoc} onClose={close} data-id="element-260" data-mp="j4fel4dywys8" />
    </footer>;
}